import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { MultipleViewTypeListActiveItemPreviewHeaderActions } from '../../../MultipleViewTypeList'
import { PageEmptyState } from '../../../PageEmptyState'
import Text from '../../../Text'
import { QA_NAME_APPLICANT_PROFILE_LOAD_RETRY } from '../RentalPortalApplicantProfile.constants'

import RefreshIcon from '../../../../icons/refresh.svg'
import RentalPortalIcon from '../../../../icons/rental-portal.svg'

function RentalPortalApplicantProfileLoadState({
  isNotFound,
  previewActionsProps,
  onClickRetry,
}) {
  const { t } = useTranslation()

  return (
    <PageEmptyState EntityIcon={RentalPortalIcon}>
      <Text isSecondary>
        {t(
          isNotFound
            ? 'RentalPortal.ApplicantProfileNotFoundKey'
            : 'RentalPortal.ApplicantProfileLoadErrorKey'
        )}
      </Text>
      {isNotFound ? null : (
        <Button.Flat
          beforeIconProps={{ Icon: RefreshIcon }}
          qaName={QA_NAME_APPLICANT_PROFILE_LOAD_RETRY}
          text={t('RentalPortal.ListingRetryBtnKey')}
          onClick={onClickRetry}
        />
      )}
      {previewActionsProps ? (
        <MultipleViewTypeListActiveItemPreviewHeaderActions
          {...previewActionsProps}
        />
      ) : null}
    </PageEmptyState>
  )
}

export default RentalPortalApplicantProfileLoadState
